<template>
  <!-- Hides itself entirely while no logo has been supplied, so production never
       shows an empty "trusted by" strip. -->
  <section v-if="visibleClients.length" class="border-b border-black/5 bg-white pb-10 pt-8" :id="id">
    <div class="mx-auto max-w-[1200px] px-6 lg:px-10">
      <p class="mb-8 text-center text-xs font-bold uppercase tracking-[0.18em] text-text-muted">
        {{ t('clients.title') }}
      </p>

      <ul class="grid grid-cols-2 items-center gap-x-8 gap-y-8 sm:grid-cols-3 lg:grid-cols-6">
        <li v-for="client in visibleClients" :key="client.name" class="flex h-12 items-center justify-center">
          <!--
            Full colour. Capping width as well as height keeps a 5.8:1 wordmark
            from dwarfing a 1.25:1 icon. Note that Sman Cars and Highmark ship as
            white artwork for dark backgrounds; the files in public/images/clients
            are light-background versions (see data/clients.ts).
          -->
          <img
            v-if="client.logo"
            :src="client.logo"
            :alt="client.name"
            class="h-auto max-h-8 w-auto max-w-[120px] object-contain opacity-90 transition-opacity duration-300 hover:opacity-100 lg:max-h-9 lg:max-w-[130px]"
            loading="lazy"
            decoding="async"
          />
          <span
            v-else
            class="flex h-12 w-full items-center justify-center rounded-xl border border-dashed border-text-main/20 px-2 text-center text-[10px] font-semibold leading-tight text-text-muted"
          >
            [PLACEHOLDER: logo {{ client.name }}]
          </span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { clientLogos } from '../../data/clients';

defineProps<{ id?: string }>();

const { t } = useI18n();

const visibleClients = computed(() =>
  clientLogos.filter((client) => import.meta.env.DEV || !client.draft)
);
</script>
